<div class="modal-body-1 alert-body-1">
    <div class="bookmark-alert-content-1 mobile-view">
        <i class="material-icons alert-btn-close" (click)="closeBookmarkAlert_2()">close</i>
        <div class="d-flex justify-content-center align-items-center flex-column">
            <h3 class="alert-popup-title-prime">Welcome to</h3>
            <h3 class="alert-popup-title-prime-1">WindowSwap All-Access!</h3>
        </div>
        <div class="d-flex justify-content-around align-items-center prime-div">
            <div class="d-flex justify-content-center align-items-center flex-column">
                <div><img class="icon-img" [src]="constants.ARROEPRIME_IMG" /></div>
                <p class="prime-text-content">Access to</p>
                <p class="prime-text-content">a back button</p>
            </div>

            <div>
                <div class="d-flex justify-content-center align-items-center flex-column">
                    <div>
                        <img class="icon-img" [src]="constants.LOCK_IMG" />
                    </div>
                    <p class="prime-text-content">Watch all videos</p>
                    <p class="prime-text-content">ever uploaded</p>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-around align-items-center prime-div-1">
            <div class="d-flex justify-content-center align-items-center flex-column">
                <div>
                    <img class="icon-img" [src]="constants.PRIME_IMG" />
                </div>
                <p class="prime-text-content">Bookmark</p>
                <p class="prime-text-content">unlimited windows</p>
            </div>

            <div>
                <div class="d-flex justify-content-center align-items-center flex-column">
                    <div>
                        <img class="icon-img" [src]="constants.MORE_IMG" />
                    </div>
                    <p class="prime-text-content">More features</p>
                    <p class="prime-text-content">coming soon!</p>
                </div>
            </div>
        </div>
    </div>
    <div class="mobile-view-one">
        <i class="material-icons alert-btn-close" (click)="closeBookmarkAlert_2()">close</i>
        <div class="
          d-flex
          justify-content-center
          align-items-center
          flex-column
          prime-div-mobile
        ">
            <h3 class="alert-popup-title-prime">Welcome to</h3>
            <h3 class="alert-popup-title-prime-1">WindowSwap All-Access!</h3>
        </div>
        <div class="
          d-flex
          justify-content-between
          align-items-center
          mobile-view-thanks
        ">
            <div class="
            d-flex
            justify-content-center
            align-items-center
            flex-column
            prime-div-mobile
          ">
                <div><img class="icon-img" [src]="constants.PRIME_IMG" /></div>
                <p class="prime-text-content">Bookmark</p>
                <p class="prime-text-content">unlimited windows</p>
            </div>
            <div class="
            d-flex
            justify-content-center
            align-items-center
            flex-column
            prime-div-mobile prime-div-mobile-1
          ">
                <div>
                    <img class="icon-img" [src]="constants.LOCK_IMG" />
                </div>
                <p class="prime-text-content">Watch all videos</p>
                <p class="prime-text-content">ever uploaded</p>
            </div>
            <div class="
            d-flex
            justify-content-center
            align-items-center
            flex-column
            prime-div-mobile prime-div-mobile-1
          ">
                <div>
                    <img class="icon-img" [src]="constants.ARROEPRIME_IMG" />
                </div>
                <p class="prime-text-content">Access to</p>
                <p class="prime-text-content">a back button!</p>
            </div>
            <div class="
            d-flex
            justify-content-center
            align-items-center
            flex-column
            prime-div-mobile prime-div-mobile-1
          ">
                <div>
                    <img class="icon-img" [src]="constants.MORE_IMG" />
                </div>
                <p class="prime-text-content">More features</p>
                <p class="prime-text-content">coming soon!</p>
            </div>
        </div>
    </div>
</div>